/*
 * Copyright (C) 2026 to Present Applause App Quality, Inc. All rights reserved.
 */

import {
  ChangeDetectionStrategy, Component, EventEmitter, Inject, Input, Output,
} from '@angular/core';
import { ActionState } from './pending';
import { itemContext } from '../community-item';
import { HideItemService } from './hide-item.service';

// Moderator hide / show for a feed card ("eye blink + collapse", COMMUNITY_ANIMATIONS.html option 3B).
// The card collapses its body when `item.state` becomes 'hidden'.
@Component({
  selector: 'ut-community-hide-action',
  templateUrl: './community-hide-action.component.html',
  styleUrls: ['./action-button.scss', './community-hide-action.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class CommunityHideActionComponent {
  @Input({ required: true }) item: any;
  @Output() stateChanged = new EventEmitter<void>();

  readonly state = new ActionState();

  constructor(
    @Inject('AlertService') private AlertService: any,
    private hideItem: HideItemService,
  ) {}

  get hidden(): boolean {
    return this.item.state === 'hidden';
  }

  // The visible word plus the card it acts on; the state is in the word, so no aria-pressed as well.
  get label(): string {
    return `${this.hidden ? 'Hidden' : 'Hide'}: ${itemContext(this.item)}`;
  }

  confirm(): void {
    if (this.state.busy()) return;
    this.hideItem.confirm(this.item).then((ok) => ok && this.toggle());
  }

  private toggle(): void {
    this.state.run(this.hideItem.toggle(this.item)).then(() => {
      this.state.complete(
        this.hidden ? 'on' : 'off',
        this.hidden ? 'Post hidden from the community' : 'Post visible to the community',
      );
      this.stateChanged.emit();
    }, () => this.AlertService.add('There was an error', 'danger'));
  }
}
